<div *ngIf="claimDto" class="position-fixed sticky-top start-0 w-100 shadow-lg border-bottom d-none d-xl-block">
  
  <div class="container-fluid bg-white pb-0">
    <app-stats [claimDto]="claimDto"></app-stats>
  </div>
  
  <div class="container-fluid bg-primary-dark text-light d-block d-md-flex">
    <app-vehicle-information
      [claim]="claimDto"
      class="d-block d-xl-flex">
    </app-vehicle-information>
    <div class="border-start border-white-35 d-none d-md-flex ps-md-4"></div>
    <app-warranty-information
      [warranty]="claimDto!.warranty"
      [IsAdjusterView]="true"
      class="pt-3 pt-1 pt-md-1">
    </app-warranty-information>
  </div>
  
  <div class="container-fluid bg-stat">
    <div class="row row-cols-auto justify-content-start">
      
      <div class="mt-auto mb-0 border-end border-1 border-gray-500 pe-3 me-2">
        <app-claim-status 
          class="d-inline-block"
          [claimDto]="claimDto!" 
          [minimalUi]="true">
        </app-claim-status>
        <app-claim-authorization-number 
          class="d-inline-block ms-4"
          [claimDto]="claimDto!" 
          [minimalUi]="true">
        </app-claim-authorization-number>
      </div>
      
      <app-assign-to [assignedAdjuster]="assignedAdjuster" (adjusterChanged)="setAdjuster($event)" [claimDto]="claimDto" class="mt-auto mb-0"></app-assign-to>
      
      <app-deductible (manuallyEnteredDeductibleChanged)="calculateTotals()" [manuallyEnteredDeductible]="claimDto.manuallyEnteredDeductible" *ngIf="claimDto.warranty?.deductible !== null" [claimDto]="claimDto" [minimalUi]="true" class="mt-auto mb-0"></app-deductible>
      
      <div class="d-flex ms-auto mt-auto mb-0">
        <div class="flex-grow-1 mt-auto">
          <app-is-claim-test-data [ClaimDto]="claimDto!" class="d-block mb-1"></app-is-claim-test-data>
          <app-update-button
            *ngIf="!claimDto!.isLocked"
            [repairTotal]="repairTotal"
            [isLocked]="claimDto!.isLocked"
            [busySubmitting]="busySubmitting"
            (updateButtonClicked)="updateClaim()">
          </app-update-button>
        </div>
        <app-approve-reject 
          *ngIf="!claimDto!.isLocked"
          class="flex-grow-1 mt-auto ms-3"
          [assignedAdjuster]="assignedAdjuster"
          [claimDto]="claimDto!" 
          [repairsDto]="repairsDto" 
          [repairTotal]="repairTotal"
          [minimalUi]="true">
        </app-approve-reject>
      </div>
      
    </div>
  </div>
  
  <div class="container-fluid bg-light border-top">
    <ul class="text-end lh-md">
      <li>
        <span>Repair Total</span>
        <span class="fs-3">{{repairTotal | currency}}</span>
      </li>
      <li *ngIf="claimDto.warranty?.deductible !== null">
        <span>Deductible</span>
        <span class="fs-3" *ngIf="claimDto">{{claimDto.manuallyEnteredDeductible ?? claimDto.warranty.deductible | currency}}</span>
      </li>
      <li *ngIf="claimDto.warranty?.deductible !== null">
        <span>Subtotal</span>
        <span class="fs-3">{{subTotal | currency}}</span>
      </li>
      <li *ngIf="pst">
        <span>PST</span>
        <span class="fs-3">{{pst | currency}}</span>
      </li>
      <li *ngIf="pst">
        <span>GST</span>
        <span class="fs-3">{{gst | currency}}</span>
      </li>
      <li *ngIf="tax">
        <span>{{claimDto!.tax.label!}}</span>
        <span class="fs-3">{{tax | currency}}</span>
      </li>
      <li>
        <span class="fw-bold">Total</span>
        <span class="fs-2 text-dark">{{total | currency}}</span>
      </li>
    </ul>
  </div>

  <div class="position-relative bg-transparent btn-sticky-header-container fade">
    <div class="bg-primary">
      <button
        class="btn btn-sticky-header btn-collapse"
        [class.collapsed]="!isOpen"
        type="button"
        [attr.aria-expanded]="isOpen ? 'true' : 'false'"
        (click)="toggleExpandCollapse()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
          <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
        </svg>
      </button>
    </div>
  </div>
  
</div>
